import { customStyles } from "components/BaseModalComponents/BasedModal";
import { Styles } from "react-modal";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 13px 22px 15px 22px;
    flex-direction: column;
    min-height: 218px;
    width: 350px;
    text-align: center;
    p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        color: #000000;
        margin-bottom: auto;
        margin-top: auto;
    }
    button {
        margin: 0 auto;
    }
`;

export const modalStyle = {
    ...customStyles,
    overlay: { ...customStyles.overlay, zIndex: 101 },
};
